import { Component, Inject, Input, OnInit, ɵConsole } from '@angular/core';
import { NdbxIcons } from '../../../../dependencies/qbe-components/src/lib/assets/fonts/ndbx-icon/ndbx-icons';
import { FormService } from '../../../shared/form.service';
import { NX_MODAL_DATA } from '@aposin/ng-aquila/modal';
import { PrintDocumentService } from 'src/app/services/print.service';
import { PrintService } from 'src/app/shared/print.service';
import { TrackService } from 'src/app/services/track.service';

interface IPackageItem {
  title: string;
  comfort: boolean;
  plus: boolean;
  extra: boolean;
  max: boolean;
  definition: string;
}

@Component({
  selector: 'app-packages-table',
  templateUrl: './packages-table.component.html',
  styleUrls: ['./packages-table.component.scss']
})


export class PackagesTableComponent implements OnInit {
  // @Input() packagesTable;
  // @Input() calculatedPremiums;
  // @Input() selectedPackage;
  packagesTable;
  calculatedPremiums;
  selectedPackage;
  selectedTab = 0;
  Icons = NdbxIcons;
  labelCoverageProvided: string = 'Coverage provided';
  labelComfort: string = 'Комфорт';
  labelPlus: string = 'Плюс';
  labelExtra: string = 'Екстра';
  labelMax: string = 'Макс';
  labelCoverageDefinitions: string = 'Coverage definitions';
  packageList: IPackageItem[] = [];
  labelDetails = {
    desktop: "Download more details",
    mobile: "Details"
  }


  constructor(public formService: FormService,private printService:PrintDocumentService, @Inject(NX_MODAL_DATA) public data: any, public trackService: TrackService) {
  }

  ngOnInit(): void {
    this.packagesTable = this.data.packagesTable;
    this.calculatedPremiums = this.data.calculatedPremiums;
    this.selectedPackage = this.data.selectedPackage;
    this.populateTable();
  }

  detailsBtnClick(){
    this.trackService.pushEventTracking('navigationButton','Download more details');
    this.printService.downloadDetails();
  }




  private populateTable() {
    this.packagesTable.forEach((element) => {
      this.packageList.push({
        title: element.title,
        comfort: element.comfort,
        plus: false, // Hidden in the component
        extra: element.extra,
        max: element.max,
        definition: element.description
      });
    });
  }
}
